module.exports = __webpack_public_path__ + "img/160x130.81380ca6.png";